import Link from "next/link";

export function Footer() {
  return (
    <footer className="border-t border-border bg-background/90 px-4 py-8">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-3 text-center text-sm text-muted-foreground sm:flex-row sm:justify-between">
        <p>&copy; {new Date().getFullYear()} Favela Tech LLC. All rights reserved.</p>
        <div className="flex flex-wrap items-center justify-center gap-4 text-sm">
          <Link href="/terms-of-service" className="hover:text-foreground">
            Terms
          </Link>
          <Link href="/privacy-policy" className="hover:text-foreground">
            Privacy
          </Link>
          <Link href="/cookie-policy" className="hover:text-foreground">
            Cookies
          </Link>
          <Link href="/refund-policy" className="hover:text-foreground">
            Refunds
          </Link>
        </div>
      </div>
    </footer>
  );
}
